import { render, staticRenderFns } from "./ChatBotDataSrcEdit.vue?vue&type=template&id=a82cbaa4"
import script from "./ChatBotDataSrcEdit.vue?vue&type=script&lang=js"
export * from "./ChatBotDataSrcEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports